import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import axios from 'axios';

import withRouter from '../libs/withRouter.jsx';
import withAuth from "../libs/withAuth.jsx";

import { Button, Heading, Modal, ModalContent, ModalHeader, ModalFooterButtons} from "monday-ui-react-core";

import mondaySdk from "monday-sdk-js";
const monday = mondaySdk();
monday.setApiVersion(config.monday_api.version);

import Monday from "../auth/useMonday.jsx";
import Loader from "../libs/loader.jsx";

import Share from "./share/share.jsx";

class DatasetShare extends React.Component
{
    constructor(props)
    {
        super(props);
        //console.log("DatasetShare constructor",this.props);
        this.params = this.props.router.params;
        
        this.user = this.props.auth.user;
        
        this.id = false;
        if( (`id` in this.props) && this.props.id!=0 )
        {
            this.id = this.props.id;
        }
        
        this.state = {
            'show': false,
            
            'dataset': {
                'id': this.id,
                'name': '',
                'description': '',
                'fields': {
                    'items': [],
                },
                'filter': false,
                'filters': {},
                'shares': {},
                'user': {},
            },
            
            'user': this.user,
        };
        
        this.openModalButtonRef = this.props.openModalButtonRef;
        this.shareRef = React.createRef();
        
        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        
        this.shareUpdate = this.shareUpdate.bind(this);
        this.save = this.save.bind(this);
        
        
        this.loader = React.createRef();
        this.synStateTimer = false;
    }
    
    async promisedSetState(newState)
    { 
        var state = this.state;
        for(let key of Object.keys(newState))
        {
            state[key] = newState[key];
        }
        
        this.state = state;
        
        var this_component = this;
        if(this.synStateTimer==false)
        {
            this.synStateTimer = setTimeout( () => { 
                this_component.setState( {...this_component.state} );
                this_component.synStateTimer = false; 
            }, 100);
        }
        
        return true;
    }
    
    async showModal()
    {
        var this_component = this;
        
        if(this_component.loader && ('current' in this_component.loader) && this_component.loader.current!=null) this_component.loader.current.showLoader();
        
        await this_component.promisedSetState({'show': true});
        
        await this_component.load();
        
        await this_component.shareRef.current.loadData();
        
        if(this_component.loader && ('current' in this_component.loader) && this_component.loader.current!=null) this_component.loader.current.hideLoader();
    }

    async closeModal()
    {
        var this_component = this;
        
        await this_component.promisedSetState({'show': false});
    }
    
    async shareUpdate(shares)
    {
        var this_component = this;
        var dataset = this_component.state.dataset;
        
        dataset.shares = {...shares};
        await this_component.promisedSetState({'dataset': {...dataset} });
    }
    
    async save(e)
    {
        //console.log("e", e);
        e.preventDefault();

        var this_component = this;
        
        if( (`id` in this_component.props) && this_component.props.id!=0 )
        {

            var data = new FormData();
            data.append('id', this_component.props.id);
            data.append('shares', JSON.stringify( this_component.state.dataset.shares ) );

            if(this_component.loader && ('current' in this_component.loader) && this_component.loader.current!=null) this_component.loader.current.showLoader();

            var url = '/api/v1/dataset/save_shares';
            if(this_component.state.user.is_admin == true && this_component.state.dataset.user.monday_user_id != this_component.state.user.id)
            {
                url = '/api/v1/dataset/admin_save_shares';
            }

            axios.post(url, data)
                .then(response => {
            
                    if(response.data.error==0)
                    {
                        monday.execute("notice", { 
                            message: 'Data Source successfully shared',
                            type: "success", // or "error" (red), or "info" (blue)
                            timeout: 10000,
                        });
                        
                        this_component.closeModal();
                    }
                    
                    if(this_component.loader && ('current' in this_component.loader) && this_component.loader.current!=null) this_component.loader.current.hideLoader();
                })
                .catch(error => {
                    console.log('DatasetShare save error', error, error.response);

                    if('error_message' in error.response.data)
                    {
                        monday.execute("notice", { 
                            message: error.response.data.error_message,
                            type: "error", // or "error" (red), or "info" (blue)
                            timeout: 30000,
                        });
                    }

                    if(this_component.loader && ('current' in this_component.loader) && this_component.loader.current!=null) this_component.loader.current.hideLoader();
                });
        }
    }
    
    async load()
    {
        var this_component = this;
        
        if( (`id` in this_component.props) && this_component.props.id!=0 )
        {
            var data = {};
            data['id'] = this_component.props.id;

            if(this_component.loader && ('current' in this_component.loader) && this_component.loader.current!=null) this_component.loader.current.showLoader();
            
            try
            {
                
                var url = '/api/v1/dataset/get';
                var response = await axios.get(url, { 'params': data} );
                
                if(response.data.error==0)
                {
                    let dataset = response.data.item;

                    if(dataset.description == null) dataset.description = '';

                    if( !(`fields` in dataset) )
                    {
                        dataset.fields = {
                            //'items': [],
                        };
                        dataset.filter = false;
                        dataset.filters = {};
                        dataset.shares = {};
                    }
                    else
                    {
                        //laravel AsArrayObject return empty object as array. we need object there
                        if(Array.isArray(dataset.fields) && dataset.fields.length == 0) dataset.fields = {};
                        dataset.fields = dataset.fields?dataset.fields:{};

                        dataset.filter = dataset.filter?dataset.filter:false;

                        if(Array.isArray(dataset.filters) && dataset.filters.length == 0) dataset.filters = {};
                        dataset.filters = dataset.filters?dataset.filters:{};
                        
                        if(Array.isArray(dataset.shares) && dataset.shares.length == 0) dataset.shares = {};
                        dataset.shares = dataset.shares?dataset.shares:{};
                    }

                    await this_component.promisedSetState({'dataset': {...dataset} });
                    
                    //console.log("dataset", {...this_component.state.dataset});
                    //console.log("user", {...this_component.state.user});
                    
                    if(this_component.loader && ('current' in this_component.loader) && this_component.loader.current!=null) this_component.loader.current.hideLoader();
                }
            }
            catch(error)
            {
                console.log('DatasetShare get error', error, error.response);

                if('error_message' in error.response.data)
                {
                    monday.execute("notice", { 
                        message: error.response.data.error_message,
                        type: "error", // or "error" (red), or "info" (blue)
                        timeout: 30000,
                    });
                }

                if(this_component.loader && ('current' in this_component.loader) && this_component.loader.current!=null) this_component.loader.current.hideLoader();
            };
        }
    }
    
    render()
    {
        var this_component = this;
       
        return (
            <div style={this_component.props.style}>
                <Modal triggerElement={this_component.openModalButtonRef.current?this_component.openModalButtonRef.current:null} show={this_component.state.show} onClose={this_component.closeModal} width={Modal.width.FULL_WIDTH} contentSpacing>
                <ModalHeader style={{'fontWeight':'bold'}}><Heading type={Heading.types.h4} style={{'fontWeight':'bold'}} value="Share settings" className="pl-0 mt-0" customColor="var(--primary-text-color)" /></ModalHeader>
                    <ModalContent>
                        <Loader ref={this_component.loader}>
                            <div className="container-fluid" style={{'color':'var(--primary-text-color)'}}>
                                <div className="row">
                                    <div className="col-12">
                                        <Share ref={this_component.shareRef} shares={ this_component.state.dataset.shares } onUpdate={this_component.shareUpdate} loadData={false} />
                                    </div>
                                </div>
                            </div>
                        </Loader>
                    </ModalContent>
                    <ModalFooterButtons primaryButtonText="Save" onPrimaryButtonClick={this_component.save} secondaryButtonText="Cancel" onSecondaryButtonClick={this_component.closeModal} />
                </Modal>
            </div>
        );
    }
}

DatasetShare.propTypes = {
    'id': PropTypes.number.isRequired,
    'style': PropTypes.object
};

DatasetShare.defaultProps = {
    style: {'display': 'none'}
};

export default withRouter(withAuth(DatasetShare));
